/**
 * @description Channel Partner My Company — channel_partners.name only (LYN-309)
 *
 * @dependencies channelPartnerApi
 * @notes Not brand. Do not paint platformName here. Invoicing is not in foundation.
 */

import { useEffect, useState } from 'react';
import {
  getChannelPartnerMe,
  updateChannelPartnerName,
} from '../../services/api/channelPartnerApi';

export default function ChannelPartnerMyCompany() {
  const [name, setName] = useState('');
  const [platformName, setPlatformName] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getChannelPartnerMe();
        if (cancelled) return;
        setName(res.data?.name || '');
        setPlatformName(res.data?.branding?.identity?.platformName || '');
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.error?.message || 'Failed to load company');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleSave = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError(null);
    setSaved(false);
    try {
      const res = await updateChannelPartnerName(name);
      setName(res.data?.name || name);
      setPlatformName(res.data?.branding?.identity?.platformName || platformName);
      setSaved(true);
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Failed to save name');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="p-6 text-sm text-gray-500">Loading…</div>;
  }

  return (
    <div className="p-6 max-w-xl">
      <h1 className="text-2xl font-bold text-gray-900">My Company</h1>
      <p className="text-sm text-gray-500 mt-1">Company name for this Channel Partner. Brand lives in Settings.</p>

      <form onSubmit={handleSave} className="mt-6 space-y-4">
        <div>
          <label htmlFor="cp-company-name" className="block text-sm font-medium text-gray-700 mb-1">
            Company name
          </label>
          <input
            id="cp-company-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm"
          />
        </div>
        {platformName ? (
          <p data-testid="cp-platform-name-aside" className="text-xs text-gray-400">
            Platform name is edited in Settings and is not this field.
          </p>
        ) : null}
        {error && <p className="text-sm text-red-600">{error}</p>}
        {saved && <p className="text-sm text-green-600">Saved</p>}
        <button
          type="submit"
          disabled={saving || !name.trim()}
          className="bg-indigo-600 text-white px-3 py-1.5 rounded-lg text-sm font-medium disabled:opacity-50"
        >
          {saving ? 'Saving…' : 'Save'}
        </button>
      </form>
    </div>
  );
}
